const authToken = 'b5207eb87640a014da2a5c7b76334e98';
export const authHeader = { Authorization: `Bearer ${authToken}` };
const baseUrl = 'https://staging-api.pixerymedia.com';
const {
  VUE_APP_API_DOMAIN: apiBaseUrl = baseUrl,
  VUE_APP_CDN_DOMAIN: proxiedCdnBaseUrl = '',
  VUE_APP_CDN_DOMAIN: cdnBaseUrl = baseUrl,
  VUE_APP_CDN_DOMAIN: panoramaCdnBaseUrl = 'https://qa.diakrit.com',
  VUE_APP_BASE_PATH: basePath = '',
} = process.env;

const joinPath = (...segs) =>
  segs.reduce((res, seg, i, segs) => {
    if (i) {
      const prev = segs[i - 1][segs[i - 1].length - 1] === '/';
      const next = seg[0] === '/';

      if (prev !== next) {
        res += seg;
      } else if (prev) {
        res += seg.slice(1);
      } else {
        res += `/${seg}`;
      }
    }
    return res;
  });

export const apiEndpointConst = (order, dataType, queryString) =>
  `${apiBaseUrl}/api/v1/${dataType}/${order}${queryString}`;

const apiSunstudiesEndpoint = (order, sunstudyId, queryString) =>
  `${apiBaseUrl}/api/v1/sunstudy/${order}/${sunstudyId}${queryString}`;

export const cdnUrl = path =>
  (!path.startsWith('http') ? joinPath(cdnBaseUrl, path) : path);

export const proxiedCDN = path =>
  (!path.startsWith('http') ? joinPath(proxiedCdnBaseUrl, path) : path);

export const cdnPanoramasUrl = path =>
  (!path.startsWith('http') ? joinPath(panoramaCdnBaseUrl, path) : path);

export const imageUrl = path =>
  (!path.startsWith('http') ? joinPath(basePath, path) : path);

export const themeUrl = imageUrl;

export default {
  apiEndpointConst,
  cdnUrl,
  proxiedCDN,
  authHeader,
  imageUrl,
  themeUrl,
};
